/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBrandLookupDto
 */
export interface UpdateBrandLookupDto {
    /**
     * Unique brand code
     * @type {string}
     * @memberof UpdateBrandLookupDto
     */
    code?: string;
    /**
     * Brand name in English
     * @type {string}
     * @memberof UpdateBrandLookupDto
     */
    nameEn?: string;
    /**
     * Brand name in Arabic
     * @type {string}
     * @memberof UpdateBrandLookupDto
     */
    nameAr?: string;
    /**
     * Brand image URL
     * @type {string}
     * @memberof UpdateBrandLookupDto
     */
    imageUrl?: string;
    /**
     * Whether the brand is active
     * @type {boolean}
     * @memberof UpdateBrandLookupDto
     */
    isActive?: boolean;
    /**
     * Sort order for display (1-1000)
     * @type {number}
     * @memberof UpdateBrandLookupDto
     */
    sortOrder?: number;
}

/**
 * Check if a given object implements the UpdateBrandLookupDto interface.
 */
export function instanceOfUpdateBrandLookupDto(value: object): value is UpdateBrandLookupDto {
    return true;
}

export function UpdateBrandLookupDtoFromJSON(json: any): UpdateBrandLookupDto {
    return UpdateBrandLookupDtoFromJSONTyped(json, false);
}

export function UpdateBrandLookupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBrandLookupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'nameAr': json['nameAr'] == null ? undefined : json['nameAr'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function UpdateBrandLookupDtoToJSON(value?: UpdateBrandLookupDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'imageUrl': value['imageUrl'],
        'isActive': value['isActive'],
        'sortOrder': value['sortOrder'],
    };
}

